
















import Header from '@/components/Header.vue';
import { Setting } from '@/types/Setting';
import Vue from 'vue';
import VueMarkdown from 'vue-markdown';

export default Vue.extend({
    name: 'FAQ',
    components: {
        VueMarkdown,
        Header,
    },
    computed: {
        faq(): Setting {
            return this.$store.getters.settingByKey('faq');
        },
    },
    mounted(): void {
        if (!this.faq) {
            this.$store.dispatch('fetchSettings');
        }
    },
});
